var React = require('react');

function CheckCircleIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"\n    .icon.check-circle .check {\n      fill:none;\n      stroke:#FFFFFF;\n      stroke-width:2;\n    }\n  "),React.createElement("g",{"transform":"translate(-17168.996 -22299)","key":1},[React.createElement("circle",{"className":"primary-fill","cx":"17179","cy":"22309","r":"10","key":0}),React.createElement("path",{"className":"check secondary-stroke","d":"M17175.8 22309.3l2.3 2.7 6-6.7","key":1})])]);
}

CheckCircleIcon.defaultProps = {"viewBox":"0 0 20 20","className":"icon check-circle"};

module.exports = CheckCircleIcon;

CheckCircleIcon.default = CheckCircleIcon;
